import * as React from 'react'
import { useLocation } from 'react-router-dom'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import NuvoImporter from 'modules/universal_importer/components/NuvoImporter'
import type { Metadata } from 'modules/universal_importer/components/NuvoImporter/types'

type LocationStateType = { employeesIds?: number[] } | null

const FijosPauseInBulkPage = () => {
  const {
    company,
    access: { locale },
  } = useCurrentSession()
  const location = useLocation()
  const state: LocationStateType = location.state
  const employeesIds = React.useMemo(() => state?.employeesIds ?? [], [state?.employeesIds])
  return (
    <ResponsivePage.Body>
      <NuvoImporter
        importType="employee_bulk_pause_importer"
        locale={locale}
        companyId={company.id}
        metadata={React.useMemo<Metadata>(() => ({ employee_ids: employeesIds }), [employeesIds])}
        isEdition
      />
    </ResponsivePage.Body>
  )
}

export default FijosPauseInBulkPage
